import { Box, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import useIsIntegrated from "../../api/hooks/useIsIntegrated";
import useMSSP from "../../api/hooks/useMSSP";
import { IntegrationsMapping } from "../stack/integrations/IntegrationsMapping";
import { categoryAccess, categoryName, pageName } from "./constants";
import { pagesByCategories } from "./pages";

export default function SettingsSideMenu({
  currentCategory,
  setCurrentCategory,
  currentPage,
  setCurrentPage,
  isAdmin,
}) {
  const colors = useColors();
  const { isMSSP } = useMSSP();

  const {
    isIntegrated: isSlackIntegrated,
    isIntegratedLoading: isSlackLoading,
  } = useIsIntegrated(IntegrationsMapping.slack.codeName);
  const {
    isIntegrated: isTeamsIntegrated,
    isIntegratedLoading: isTeamsLoading,
  } = useIsIntegrated(IntegrationsMapping.microsoft_teams.codeName);
  const pageIsLoading = isSlackLoading || isTeamsLoading;

  const anyNotificationIntegrationExists =
    isSlackIntegrated || isTeamsIntegrated;

  const disabledPagesWhenLoading = [pageName.RISK, pageName.ASSETS];

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1.5}
      width="200px"
      paddingRight={2}
    >
      {Object.entries(pagesByCategories).map(([category, categoryData]) => {
        if (categoryData.access === categoryAccess.MANAGERS_ONLY && !isAdmin)
          return null;
        if (categoryData.access === categoryAccess.ALL_BUT_MSSP && isMSSP)
          return null;
        return (
          <Box key={category} display="flex" flexDirection="column">
            <Box display="flex" flexDirection="column">
              <Box height="32px" display="flex" alignItems="center">
                <Typography variant="subtitle2" color={colors.text_secondary}>
                  {categoryData.menuTitle}
                </Typography>
              </Box>
              {Object.entries(categoryData.pages).map(([page, pageData]) => {
                const isCurrentPage =
                  category === currentCategory && page === currentPage;

                const disabled =
                  (pageIsLoading || !anyNotificationIntegrationExists) &&
                  category === categoryName.ORGANIZATION_NOTIFICATIONS &&
                  disabledPagesWhenLoading.includes(page);

                return (
                  <Box
                    key={category + page}
                    height="32px"
                    display="flex"
                    alignItems="center"
                    paddingLeft={1}
                    onClick={() => {
                      if (disabled) return;
                      if (category !== currentCategory)
                        setCurrentCategory(category);
                      if (page !== currentPage) setCurrentPage(page);
                    }}
                    sx={{
                      cursor: isCurrentPage || disabled ? "default" : "pointer",
                      "&:hover": {
                        backgroundColor: isCurrentPage
                          ? colors.primary_8percent
                          : disabled
                          ? null
                          : colors.action_hover,
                        "& .hover-text": {
                          color: isCurrentPage
                            ? colors.text_selected
                            : disabled
                            ? colors.text_disabled
                            : colors.text_secondary,
                        },
                      },
                      backgroundColor: isCurrentPage
                        ? colors.primary_8percent
                        : null,
                      borderRadius: "8px",
                    }}
                  >
                    <Typography
                      className="hover-text"
                      variant="body2"
                      color={
                        isCurrentPage
                          ? colors.text_selected
                          : disabled
                          ? colors.text_disabled
                          : colors.text_primary
                      }
                    >
                      {pageData.menuTitle}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
